export const CIRCLES_CANDIDATES_FETCH = 'circles/candidates/fetch';
export const CANDIDATES_DETAILS_FETCH = 'candidates/details/fetch';
export const COMPANY_INFO_FETCH = 'company/info/fetch';

export const CANDIDATES_ACTIVITIES_FETCH = 'candidates/activities/fetch';
